export type ScrapperEventStatus = 'pending' | 'processing' | 'completed' | 'failed';
export type ScrapperEventType = 'daily' | 'historical' | 'accounts_by_code';

export interface ScrapperEventListItem {
  id: string;
  scrapperId: string;
  status: ScrapperEventStatus;
  eventType: ScrapperEventType;
  attempts: number;
  fileName: string | null;
  s3Key: string | null;
  bucket: string | null;
  errorCode: string | null;
  errorMessage: string | null;
  failedStep: string | null;
  uploadedAt: string | null;
  lastScrapperAt: string;
  processedAt: string | null;
  createdAt: string;
  company: { id: string; taxId: string | null; businessName: string | null };
  acquirer: { id: string; slug: string; name: string };
}

export interface ScrapperEventsListResult {
  page: number;
  pageSize: number;
  total: number;
  items: ScrapperEventListItem[];
}

export interface ScrapperEventStats {
  total24h: number;
  pending: number;
  processing: number;
  completed24h: number;
  failed: number;
  failedToday: number;
  successRate24h: number;
  byEventType: { eventType: ScrapperEventType; count: number }[];
  topErrors: { errorCode: string; count: number }[];
  recentFailures: {
    id: string;
    errorCode: string | null;
    failedStep: string | null;
    createdAt: string;
    companyName: string | null;
    acquirerSlug: string;
  }[];
}

export const STATUS_LABELS: Record<ScrapperEventStatus, string> = {
  pending: 'Pendiente',
  processing: 'Procesando',
  completed: 'Completado',
  failed: 'Fallido',
};

export const EVENT_TYPE_LABELS: Record<ScrapperEventType, string> = {
  daily: 'Diario',
  historical: 'Histórico',
  accounts_by_code: 'Cuentas x código',
};
